import React, { useState, useEffect } from "react";
// import AreaGraph from "./AreaGraph";
import Graph from "../MeDasboard/Graph";
import FilterBy from "../utils/FilterBy";
import { FaMedal } from "react-icons/fa";
import { Info } from "lucide-react"
import "./styles/TeamsDashboard.css";
import "../Teams/Leaderboard/LeaderBoard.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import DonutChart from "./DonutChart";
import { toApiDate, toApiDate1, isDateRangeValid } from "../utils/DateUtils";
import getNiceYAxisMax from "../../components/utils/getNiceAxisMax";
import axios from "axios";
import OverlaySpinner from "../Loaders/OverlaySpinner";
import SkeletonLoader from "../Loaders/SkeletonLoader";
import openNotification from "../utils/CustomNotification";
import User from "../assets/User.png"
import moment from "moment-timezone";
import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";
import { SessionExtend } from "components/utils/SessionCheckUtils";
import { FaUserCircle, FaEnvelope, FaBuilding, FaCity, FaUsers, FaPhoneAlt, FaGlobe } from "react-icons/fa";
import { handleGlobalError, resetGlobalErrorFlag } from "components/utils/ErrorManager";



const API_URL_HIERARCHY = `${process.env.REACT_APP_API_URL}/api/get-team-summarized-metrics`;
const API_URL_AGE_STATS = `${process.env.REACT_APP_API_URL}/api/get-group-age-group-stats`;
const LEADERBOARD_API_URL = `${process.env.REACT_APP_API_URL}/api/get-team-leaderboard`;
const API_URL_GROUPS = `${process.env.REACT_APP_API_URL}/api/groups`;


interface LeaderboardEntry {
  rank: number;
  name: string;
  points: number;
  unit: string;
  image: string;
  user_uid: string;
}

interface LeaderboardEntry {
  rank: number;
  name: string;
  points: number;
  iconColor?: string;
  unit: string;
  user_uid: string;
  showIcon: boolean;
}

interface TeamData {
  group_uid: string;
  group_name: string;
}

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const TeamsDashboard: React.FC = () => {
  useCheckSessionHeartBeat();
  const [selectedFilter, setSelectedFilter] = useState(" ");
  const userTimeZone = "Asia/Kolkata";
  const today = moment().tz(userTimeZone).startOf("day").toDate();

  // console.log(today);
  const sevenDaysAgo = moment(today).subtract(6, "days").toDate();

  // console.log("📆 Final Date Range:", sevenDaysAgo, today);


  const [selectedDate, setSelectedDate] = useState<[Date | null, Date | null]>([sevenDaysAgo, today]);

  // console.log("Start and end date:", selectedDate);

  const [sessionUid, setSessionUid] = useState("");
  const [userUid, setUserUid] = useState("");
  const [topMembers, setTopMembers] = useState<LeaderboardEntry[]>([]);

  const [currentMetric, setCurrentMetric] = useState("steps");
  const [showActivityTooltip, setShowActivityTooltip] = useState(false);
  const [showTopMembersTooltip, setShowTopMembersTooltip] = useState(false);
  const [ageGroupStatistics, setAgeGroupStatistics] = useState(false);
  const [groupUid, setGroupUid] = useState<string | null>(null);
  const [ageData, setAgeData] = useState<{ label: string; value: number; color: string }[]>([]);
  const [teamTrends, setTeamTrends] = useState<any[]>([]);
  const [yAxisMax, setYAxisMax] = useState<number | undefined>(undefined);
  const [allTeamTrends, setAllTeamTrends] = useState<TeamTrendDataWithColor[]>([]);
  const [rawTeamMetrics, setRawTeamMetrics] = useState<any[]>([]);
  const [groupUidsList, setGroupUidsList] = useState<string[]>([]);
  const [teamFilterOptions, setTeamFilterOptions] = useState<string[]>([]);
  const [teamNameUidMap, setTeamNameUidMap] = useState<Record<string, string>>({});
  const [trendMetric, setTrendMetric] = useState("performance");
  const [overallSummaryData, setOverallSummaryData] = useState<any[]>([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [isProfilePopupOpen, setIsProfilePopupOpen] = useState(false);
  const [userProfile, setUserProfile] = useState<any>(null);
  // const [userImages, setUserImages] = useState<{ [key: string]: string }>({});
  const [dataLoading, setDataLoading] = useState(true);
  const [isGroupReady, setIsGroupReady] = useState(false);
  const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);
  const [tempFilter, setTempFilter] = useState("All Teams");
  const sid = localStorage.getItem("session_uid") ?? "";
  const uid = localStorage.getItem("user_uid") ?? "";
  const [selectedTeamUid, setSelectedTeamUid] = useState<string | null>(null);



  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;


  const [graphData, setGraphData] = useState<{ target: number[]; achieved: number[]; labels: string[] }>({
    target: [],
    achieved: [],
    labels: []
  });
  const fetchUserProfile = async (user_uid: string) => {
    try {
      const response = await axios.get(`${beAddress}/api/public-user-profile`, {
        headers: {
          "Content-Type": "application/json",
          "user-uid": userUid,
        },
        params: {
          target_user_uid: user_uid,
        }, withCredentials: true,
      });

      if (response.data.status === "Success" && typeof response.data.data === "object") {
        const userData = response.data.data;

        if (!userProfile?.image && userData.image) {
          const isValidBase64 = /^(?:[A-Za-z0-9+/]{4})*?(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
          if (isValidBase64.test(userData.image)) {
            let mimeType = "image/png";
            if (userData.image.startsWith("R0lGODlh")) mimeType = "image/gif";
            else if (userData.image.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (userData.image.startsWith("iVBORw0KGgo")) mimeType = "image/png";

            userData.image = `data:${mimeType};base64,${userData.image}`;
          }
        } else {
          userData.image = null;
        }

        setUserProfile((prev: any) => ({
          ...prev,
          ...userData,
          image: prev?.image || userData.image || null,
        }));
      } else {
        console.error("Invalid data format in API response");
      }
      SessionExtend();
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };


  const [selectedGroupUid, setSelectedGroupUid] = useState<string | null>(null);
  const [shouldFetchData, setShouldFetchData] = useState(false);

  useEffect(() => {
    const sid = localStorage.getItem("session_uid") ?? "";
    const uid = localStorage.getItem("user_uid") ?? "";
    resetGlobalErrorFlag();

    setSessionUid(sid);
    setUserUid(uid);

    if (
      Array.isArray(selectedDate) &&
      selectedDate[0] instanceof Date &&
      selectedDate[1] instanceof Date
    ) {
      const diffInDays =
        (selectedDate[1].getTime() - selectedDate[0].getTime()) / (1000 * 60 * 60 * 24);

      if (diffInDays > 29) {
        openNotification({
          type: "warning",
          message: "Date range must be within 30 days.",
        });
        return;
      }
    }

    const fetchGroups = async () => {
      try {
        const res = await axios.get(API_URL_GROUPS, {
          headers: {
            "user-uid": uid,
          }, withCredentials: true,
        });

        if (
          res.status === 200 &&
          res.data?.status === "Failed" &&
          res.data?.data?.toLowerCase?.() === "access denied"
        ) {
          handleGlobalError("Access Denied: You do not have permission to view groups.");
          return;
        }

        const teams = res.data?.data ?? [];

        if (teams.length > 0) {
          const nameUidMap: Record<string, string> = {};
          teams.forEach((t: any) => {
            nameUidMap[t.group_name] = t.group_uid;
          });

          setTeamNameUidMap(nameUidMap);

          const defaultGroup = teams[0];
          const defaultName = defaultGroup.group_name;
          const defaultUid = defaultGroup.group_uid;

          const allNames = teams.map((t: any) => t.group_name);
          const reordered = [defaultName, ...allNames.filter((n: any) => n !== defaultName)];
          setTeamFilterOptions(reordered);

          const activeGroupUid = selectedGroupUid || defaultUid;
          const activeGroupName = Object.keys(nameUidMap).find(
            (name) => nameUidMap[name] === activeGroupUid
          ) || defaultName;

          setSelectedFilter(activeGroupName);
          setSelectedGroupUid(activeGroupUid);

          if (selectedDate[0] && selectedDate[1]) {
            fetchTeamMetrics(selectedDate[0], selectedDate[1], activeGroupUid);
            fetchTopMembers(selectedDate[0], selectedDate[1], activeGroupUid);
            fetchAgeGroupStats([activeGroupUid]);
          }
        } else {
          setTeamNameUidMap({});
          setSelectedFilter("");
          setSelectedGroupUid("");
          setTeamFilterOptions([]);

          if (selectedDate[0] && selectedDate[1]) {
            fetchTeamMetrics(selectedDate[0], selectedDate[1], "");
            fetchTopMembers(selectedDate[0], selectedDate[1], "");
            fetchAgeGroupStats([]);
          }

          openNotification({
            type: "info",
            message: "No Teams available. Displaying all teams without filters.",
          });
        }
      } catch (err) {
        console.error("Error fetching groups:", err);
        openNotification({
          type: "error",
          message: "Failed to fetch teams. Please try again.",
        });
      }
    };

    fetchGroups();
  }, [selectedDate]);


  useEffect(() => {
    if (rawTeamMetrics.length && selectedDate[0] && selectedDate[1]) {
      processTeamGraphData(rawTeamMetrics, selectedDate[0], selectedDate[1], currentMetric);
    }
  }, [currentMetric]);




  // useEffect(() => {
  //   if (!shouldFetchData || !selectedDate[0] || !selectedDate[1]) return;

  //   const groupUid = selectedGroupUid; 

  //   fetchTeamMetrics(selectedDate[0], selectedDate[1], groupUid||undefined);
  //   fetchTopMembers(selectedDate[0], selectedDate[1], groupUid||undefined);
  //   fetchAgeGroupStats(groupUid ? [groupUid] : undefined);

  //   setShouldFetchData(false);
  // }, [shouldFetchData]);



  const formatDateTime = (date: Date) => {
    return date.toISOString().split("T")[0] + "T00:00:00Z";
  };

  interface TeamMetrics {
    name: string;
    target: number[];
    achieved: number[];
  }
  interface TeamTrendData {
    name: string;
    members: number;
    data: number[];
    avg: number;
  }
  interface TeamTrendDataWithColor extends TeamTrendData {
    color: string;
  }

  const fetchTeamMetrics = async (fromDate: Date, toDate: Date, group_uid?: string) => {
    try {
      setDataLoading(true);

      const response = await axios.get(API_URL_HIERARCHY, {
        params: {
          from_datetime: moment(fromDate).tz(userTimeZone).format("YYYY-MM-DDTHH:mm:ss"),
          to_datetime: moment(toDate).tz(userTimeZone).format("YYYY-MM-DDTHH:mm:ss"),
          ...(group_uid && { group_uid })
        },
        headers: {
          "user-uid": uid,
          accept: "application/json",
        }, withCredentials: true,
      });

      const res = response.data;

      if (res.status === "Failed") {
        if (res.data?.toLowerCase?.() === "access denied") {
          handleGlobalError("Access Denied: You do not have permission to view team metrics.");
        } else {
          handleGlobalError(res.message || "Failed to fetch team metrics.");
        }
        return;
      }

      const data = res.data;
      if (!data || typeof data !== "object" || !Array.isArray(data.teams_summary)) {
        if (typeof data === "string" && data.toLowerCase() === "access denied") {
          handleGlobalError("Access Denied: You do not have permission to view team metrics.");
        } else {
          openNotification({
            type: "warning",
            message: "No data available. Please select today's or a past date.",
          });
        }
        return;
      }


      const teamsSummary = data.teams_summary;
      const overallSummary = data.overall_summary || [];

      setRawTeamMetrics(teamsSummary);
      setOverallSummaryData(overallSummary);
      processTeamGraphData(teamsSummary, fromDate, toDate, currentMetric);
      SessionExtend();
    } catch (error) {
      console.error("Error fetching team metrics:", error);
      handleGlobalError("Something went wrong while fetching team metrics.");
    } finally {
      setDataLoading(false);
    }
  };


  const processTeamGraphData = (
    data: any[],
    fromDate: Date,
    toDate: Date,
    metric: string
  ) => {
    const dateMap: Record<string, { target: number; achieved: number }> = {};

    const dateIterator = moment(fromDate).tz(userTimeZone).startOf("day");
    const endDate = moment(toDate).tz(userTimeZone).startOf("day");

    while (dateIterator.isSameOrBefore(endDate)) {
      const key = dateIterator.format("YYYY-MM-DD");
      dateMap[key] = { target: 0, achieved: 0 };
      dateIterator.add(1, "day");
    }

    const key = metric.toLowerCase();

    data.forEach((team: any) => {
      team.data.forEach((entry: any) => {
        const entryDate = new Date(entry.date).toISOString().split("T")[0];
        if (dateMap[entryDate]) {
          entry.metrics
            .filter((m: any) => m.type === "daily")
            .forEach((m: any) => {
              const value = m[key]?.value ?? 0;
              const target = m[key]?.target ?? 0;
              const adjustedValue = key === "distance" ? value / 1000 : value;
              const adjustedTarget = key === "distance" ? target / 1000 : target;

              dateMap[entryDate].achieved += adjustedValue;
              dateMap[entryDate].target += adjustedTarget;
            });
        }
      });
    });

    const sortedDates = Object.keys(dateMap).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    const dateObjs = sortedDates.map((d) => new Date(d));
    const labels = dateObjs.map((date, index) =>
      formatDateLabel(date, index, dateObjs)
    );


    const target = sortedDates.map((date) => dateMap[date].target);
    const achieved = sortedDates.map((date) => dateMap[date].achieved);

    // console.log("GRAPH DATA:", { labels, target, achieved });

    setGraphData({ labels, target, achieved });

    const maxTarget = Math.max(...target);
    const maxAchieved = Math.max(...achieved);
    const rawMax = Math.max(maxTarget, maxAchieved);
    const computedYAxisMax = getNiceYAxisMax(rawMax);
    setYAxisMax(computedYAxisMax);
  };

  const applyTeamTrendFilter = (
    filter: string,
    data: TeamTrendDataWithColor[],
    overallAvg: number
  ) => {
    if (filter === "Top Teams") {
      setTeamTrends(data.filter(team => team.avg > overallAvg));
    } else if (filter === "Least Active Teams") {
      setTeamTrends(data.filter(team => team.avg < overallAvg));
    } else {
      setTeamTrends(data);
    }
  };

  const processTeamTrendsData = (
    summary: any[] = rawTeamMetrics,
    trendMetric: string = currentMetric
  ) => {
    if (!summary?.length) return;

    const processed: TeamTrendDataWithColor[] = summary.map((team: any) => {
      const dataPoints: number[] = [];

      team.data.forEach((day: any) => {
        const dailyMetric = day.metrics?.find((m: any) => m.type === "daily");

        let value = 0;
        if (trendMetric === "performance") value = dailyMetric?.avg_performance ?? 0;
        else if (trendMetric === "steps") value = dailyMetric?.steps?.performance ?? 0;
        else if (trendMetric === "distance") value = dailyMetric?.distance?.performance ?? 0;
        else if (trendMetric === "calories") value = dailyMetric?.caloriesburned?.performance ?? 0;

        dataPoints.push(value);
      });

      const avg = dataPoints.length
        ? dataPoints.reduce((sum, v) => sum + v, 0) / dataPoints.length
        : 0;

      return {
        name: team.group_name,
        members: team.user_count,
        data: dataPoints,
        avg,
        color:
          avg > 30
            ? "#00AEEF"
            : avg < 20
              ? "#FF4D4D"
              : "#4B9CD3",
      };
    });

    const overallAvg = processed.length
      ? processed.reduce((sum, t) => sum + t.avg, 0) / processed.length
      : 0;

    setAllTeamTrends(processed);
    applyTeamTrendFilter(selectedFilter, processed, overallAvg);
  };



  const getDateRange = (start: Date, end: Date): Date[] => {
    const dateArray: Date[] = [];
    let currentDate = new Date(start);

    while (currentDate <= end) {
      dateArray.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateArray;
  };

  const formatDateLabel = (date: Date, index: number, allDates: Date[]): string => {
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];

    if (index === 0) return `${month} ${day}`;

    const prevDate = allDates[index - 1];
    const isNewMonth = prevDate.getMonth() !== date.getMonth();

    return isNewMonth ? `${month} ${day}` : `${day}`;
  };

  const toggleMetric1 = (metric: string) => {
    setCurrentMetric(metric);
  };


  const apexSeries = [
    { name: "Achieved", data: graphData.achieved },
    { name: "Goal", data: graphData.target }
  ];

  const apexCategories = graphData.labels;


  const COLORS = ["#00AEEF", "#FF4D4D", "#FFC107", "#4CAF50", "#9C27B0"];

  const filterDataByTeamUid = (uid: string) => {
    if (!uid || !selectedDate[0] || !selectedDate[1]) return;

    setGroupUid(uid);
    fetchTeamMetrics(selectedDate[0], selectedDate[1], uid);
    fetchTopMembers(selectedDate[0], selectedDate[1], uid);
    fetchAgeGroupStats([uid]);
  };
  const fetchTopMembers = async (fromDate: Date, toDate: Date, groupUid?: string) => {
    try {
      const params: any = {
        from_datetime: moment(fromDate).tz(userTimeZone).format("YYYY-MM-DDTHH:mm:ss"),
        to_datetime: moment(toDate).tz(userTimeZone).format("YYYY-MM-DDTHH:mm:ss"),
        ...(groupUid && { group_uid: groupUid })
      };

      const response = await axios.get(LEADERBOARD_API_URL, {
        headers: {
          "user-uid": uid,
        }, withCredentials: true,
        params
      });

      const res = response.data;

      if (res.status === "Failed") {
        if (res.data?.toLowerCase?.() === "access denied") {
          handleGlobalError("Access Denied: You do not have permission to view top members.");
        } else {
          handleGlobalError(res.message || "Failed to fetch top members.");
        }
        return;
      }

      if (res.data) {
        const mapped = res.data.slice(0, 3).map((member: any, index: number) => {
          let image = User;
          const base64Pattern = /^(?:[A-Za-z0-9+/]{4})*?(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
          const dummyImage = "R0lGODlhAQABAIABAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICRAEAOw==";

          if (
            member.image &&
            member.image !== dummyImage &&
            base64Pattern.test(member.image)
          ) {
            let mimeType = "image/png";
            if (member.image.startsWith("R0lGODlh")) mimeType = "image/gif";
            else if (member.image.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (member.image.startsWith("iVBORw0KGgo")) mimeType = "image/png";

            image = `data:${mimeType};base64,${member.image}`;
          }

          return {
            rank: index + 1,
            name: member.user_name,
            points: member.value,
            unit: member.unit,
            image,
            user_uid: member.user_uid,
          };
        });

        setTopMembers(mapped);
      }

      SessionExtend();
    } catch (error) {
      console.error("Failed to fetch leaderboard:", error);
      handleGlobalError("Something went wrong while fetching top members.");
    }
  };




  const fetchAgeGroupStats = async (uids?: string[], session_uid?: string) => {
    try {
      const params: any = {};
      if (uids && uids.length === 1) {
        params.group_uid = uids[0];
      }

      const response = await axios.get(API_URL_AGE_STATS, {
        params,
        headers: {
          "user-uid": uid,
        }, withCredentials: true,
      });

      const res = response.data;

      if (res.status === "Failed") {
        if (res.data?.toLowerCase?.() === "access denied") {
          handleGlobalError("Access Denied: You do not have permission to view age group stats.");
        } else {
          handleGlobalError(res.message || "Failed to fetch age group stats.");
        }
        return;
      }

      if (res.status === "Success") {
        const stats = res?.data?.stats?.percentage_distribution ?? {};
        const processed = [
          { label: "0-18", value: stats["0-18"] ?? 0, color: "#FF6384" },
          { label: "18-25", value: stats["18-25"] ?? 0, color: "#36A2EB" },
          { label: "25-35", value: stats["25-35"] ?? 0, color: "#FFCE56" },
          { label: "35-45", value: stats["35-45"] ?? 0, color: "#4BC0C0" },
          { label: "45-60", value: stats["45-60"] ?? 0, color: "#9966FF" },
          { label: "60+", value: stats["60+"] ?? 0, color: "#E7E9ED" },
        ].filter(entry => entry.value > 0);

        setAgeData(processed);
      }

      SessionExtend();
    } catch (error) {
      console.error("Error fetching age group stats:", error);
      handleGlobalError("Something went wrong while fetching age group stats.");
    }
  };

  const [metricUnits, setMetricUnits] = useState({
    steps: "count",
    distance: "km",
    caloriesburned: "kcal",
  });

  const toggleTooltip = (tooltip: string) => {
    if (tooltip === "activity") {
      setShowActivityTooltip((prev) => !prev);
      setShowTopMembersTooltip(false);
      setAgeGroupStatistics(false);
    } else if (tooltip === "top") {
      setShowTopMembersTooltip((prev) => !prev);
      setShowActivityTooltip(false);
      setAgeGroupStatistics(false);
    } else if (tooltip === "age") {
      setAgeGroupStatistics((prev) => !prev);
      setShowActivityTooltip(false);
      setShowTopMembersTooltip(false);
    }
    setTimeout(() => {
      setShowActivityTooltip(false);
      setShowTopMembersTooltip(false);
      setAgeGroupStatistics(false);
    }, 3000);
  };

  const onMemberClick = (member: LeaderboardEntry) => {
    setUserProfile(member);
    setIsProfilePopupOpen(true);
    fetchUserProfile(member.user_uid);
  };


  return (
    <div className="teams-dashboard">
      {/* Top Header */}
      <header className="dashboard-header">
        <div className="Teamsheading"><p>Teams Dashboard</p></div>
        <div className="TeamsUtil">

          <FilterBy
            options={teamFilterOptions}
            value={selectedFilter}
            heading="Filter by"
            onFilterChange={(filter) => {
              const selectedUid = teamNameUidMap[filter];

              if (selectedUid && selectedDate[0] && selectedDate[1]) {
                filterDataByTeamUid(selectedUid);
              }

              if (filter !== selectedFilter) {
                setSelectedFilter(filter);
                setSelectedGroupUid(selectedUid);
              }
            }}
          />
          <div className="date-range-container">
            <div className="date-picker">
              <label>START DATE
                <input
                  type="date"
                  value={
                    Array.isArray(selectedDate) && selectedDate[0]
                      ? selectedDate[0].toLocaleDateString("en-CA")
                      : ""
                  }
                  max={moment().tz(userTimeZone).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setSelectedDate([
                      new Date(e.target.value),
                      Array.isArray(selectedDate) ? selectedDate[1] : null,
                    ])
                  }
                />
              </label>
            </div>
            <div className="date-picker">
              <label>END DATE
                <input
                  type="date"
                  value={
                    Array.isArray(selectedDate) && selectedDate[1]
                      ? selectedDate[1].toLocaleDateString("en-CA")
                      : ""
                  }
                  max={moment().tz(userTimeZone).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setSelectedDate([
                      Array.isArray(selectedDate) ? selectedDate[0] : null,
                      new Date(e.target.value),
                    ])
                  }
                />
              </label>
            </div>
          </div>
          {/* <button className="GenerateReportButton">
          <span>Generate Report</span>
          <RiPrinterLine />
        </button> */}
        </div>
      </header>

      {/* Grid Section */}
      {filterLoading && <OverlaySpinner />}
      <div className="dashboard-grid-new">
        {/* Row 1: Top Members + Age Group Stats */}
        <div className="top-row">
          {/* Top Members */}
          <div className="top-members-parent">
            <div className="headerWithInfoIcon" style={{ paddingTop: "0" }}>
              <div className="headerWithInfoIcon-title">Top Members</div>
              <div className="headingInfo-icon" onClick={() => toggleTooltip("top")}>
                <Info size={20} />
                {showTopMembersTooltip && (
                  <div className="tooltip">This graph shows Top Members.</div>
                )}
              </div>
            </div>
            <div className="top-members">
              {dataLoading ? (
                <SkeletonLoader type="leaderboard" />
              ) : topMembers.length > 0 ? (
                <div
                  className={`members-triangle-layout ${topMembers.length === 2 ? "two-members" : ""
                    }`}
                >
                  {[1, 0, 2].map((index, slot) => {
                    const member = topMembers[index];
                    const place = ["second-place", "first-place", "third-place"][slot];
                    const medalColors = ["#C0C0C0", "#FFD700", "#CD7F32"];

                    return (
                      <div
                        className={`member-card ${place}`}
                        key={member?.user_uid || `empty-${slot}`}
                        onClick={member ? () => onMemberClick(member) : undefined}
                      >
                        {member?.image ? (
                          <img
                            src={member.image || User}
                            alt={member.name}
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.onerror = null;
                              target.src = User;
                            }}
                          />
                        ) : (
                          <FaUserCircle style={{ fontSize: slot === 1 ? "140px" : "120px", color: "gray", opacity: 0.3 }} />
                        )}

                        <div className="member-info">
                          <p>{member?.name || "—"}</p>
                          <span>{member?.points ? `${member.points} ${member.unit}` : "—"}</span>
                        </div>
                        <FaMedal className="medal-icon" color={medalColors[slot]} />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="no-data-message">Leaderboard data not available</div>
              )}
            </div>
          </div>

          {/* Age Group Stats */}
          <div className="age-statistics-parent">
            <div className="headerWithInfoIcon" style={{ paddingTop: "0" }}>
              <div className="headerWithInfoIcon-title">Age Group Statistics</div>
              <div className="headingInfo-icon" onClick={() => toggleTooltip("age")}>
                <Info size={20} />
                {ageGroupStatistics && (
                  <div className="tooltip">This chart shows age group statistics.</div>
                )}
              </div>
            </div>
            <div className="age-statistics">
              {dataLoading ? (
                <SkeletonLoader type="donut" />
              ) : ageData.length > 0 ? (
                <DonutChart cx={100} cy={100} radius={80} data={ageData} />
              ) : (
                <div className="no-data-message">Currently not in any teams</div>
              )}
            </div>
          </div>
        </div>

        <div className="activityOverview-parent-full">
          <div className="headerWithInfoIcon" style={{ paddingTop: "0" }}>
            <div className="headerWithInfoIcon-title" style={{ marginTop: "5px" }}>Activity Overview</div>
            <div className="headingInfo-icon" onClick={() => toggleTooltip("activity")}>
              <Info size={20} />
              {showActivityTooltip && (
                <div className="tooltip">This graph shows activity overview for the teams.</div>
              )}
            </div>
          </div>

          <div className="activity-overview">
            {dataLoading ? (
              <SkeletonLoader type="vertical-chart" />
            ) : graphData.labels.length > 0 ? (
              <Graph
                type="bar"
                series={[
                  { name: "Goal", data: graphData.target },
                  { name: "Achieved", data: graphData.achieved }
                ]}
                categories={graphData.labels}
                onMetricChange={(metric) => setCurrentMetric(metric)}
                selectedMetric={currentMetric}
                yAxisMax={yAxisMax}
                units={metricUnits}
              />
            ) : (
              <div className="no-data-message">Currently not in any teams</div>
            )}
          </div>
        </div>

        {/* Profile popup if any */}
        {isProfilePopupOpen && userProfile && (
          <div className="member-profile-popup">
            <div className="member-profile-popup-content">
              <span
                className="member-profile-close"
                onClick={() => setIsProfilePopupOpen(false)}
              >
                &times;
              </span>

              <div className="member-profile-header">
                {userProfile.image ? (
                  <img
                    src={userProfile.image}
                    alt={`${userProfile.first_name} ${userProfile.last_name}`}
                    className="member-profile-image"
                  />
                ) : (
                  <FaUserCircle className="member-profile-placeholder" />
                )}
                <div className="member-name-job">
                  <h2>{`${userProfile.first_name} ${userProfile.last_name}`}</h2>
                  <p className="member-job-title">{userProfile.job_title}</p>

                  {/* uncomment to have the Active and Inactive tags */}

                  {/* <p
            className={`status-label ${
              userProfile.user_status === "active" ? "active" : "inactive"
            }`}
          >
            {userProfile.user_status === "active" ? (
              <>
                <span className="dot green-dot" /> Active
              </>
            ) : (
              <>
                <span className="dot red-dot" /> Inactive
              </>
            )}
          </p> */}
                </div>
              </div>

              <div className="leaderboard-member-details">
                <div className="leaderboard-popup-row">
                  <FaEnvelope className="leaderboard-popup-icon" />
                  <div className="leaderboard-popup-text">
                    <div className="leaderboard-popup-label">Email:</div>
                    <div className="leaderboard-popup-value">{userProfile.email}</div>
                  </div>
                </div>
                <div className="leaderboard-popup-row">
                  <FaBuilding className="leaderboard-popup-icon" />
                  <div className="leaderboard-popup-text">
                    <div className="leaderboard-popup-label">Department:</div>
                    <div className="leaderboard-popup-value">{userProfile.department}</div>
                  </div>
                </div>
                <div className="leaderboard-popup-row">
                  <FaPhoneAlt className="leaderboard-popup-icon" />
                  <div className="leaderboard-popup-text">
                    <div className="leaderboard-popup-label">Mobile:</div>
                    <div className="leaderboard-popup-value">
                      {userProfile.mobile_phone || "-"}
                    </div>
                  </div>
                </div>
                <div className="leaderboard-popup-row">
                  <FaGlobe className="leaderboard-popup-icon" />
                  <div className="leaderboard-popup-text">
                    <div className="leaderboard-popup-label">Nationality:</div>
                    <div className="leaderboard-popup-value">
                      {userProfile.nationality || "-"}
                    </div>
                  </div>
                </div>
                <div className="leaderboard-popup-row">
                  <FaCity className="leaderboard-popup-icon" />
                  <div className="leaderboard-popup-text">
                    <div className="leaderboard-popup-label">City:</div>
                    <div className="leaderboard-popup-value">{userProfile.city || "-"}</div>
                  </div>
                </div>
                <div className="leaderboard-popup-row">
                  <FaUsers className="leaderboard-popup-icon" />
                  <div className="leaderboard-popup-text">
                    <div className="leaderboard-popup-label">Team:</div>
                    <div className="leaderboard-popup-value">{userProfile.team || "-"}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );

};

export default TeamsDashboard;
